import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bmr',
  templateUrl: './bmr.component.html',
  styleUrls: ['./bmr.component.scss']
})
export class BmrComponent implements OnInit {

  constructor(private router: Router) {}

  user: any;
  urlArcgis2: any;

  stateModalDownload = false;
  buttonState = false;

  url = environment.base_bmr;

  ngOnInit(): void {

    this.user = JSON.parse(
      localStorage.getItem('user') || '{}'
    );

    this.urlArcgis2 = JSON.parse(
      localStorage.getItem('gis') || '{}'
    );

    const serviceUnit = JSON.parse(
      localStorage.getItem('serviceUnit') || '{}'
    );

    const isVibration =
      serviceUnit.name === 'Monitoreo de vibraciones';

    this.buttonState =
      !isVibration && this.urlArcgis2?.download;

    if (isVibration) {
    
      document
        .getElementById('idframe')
        ?.setAttribute('src', this.url);
    
    }
  }

  openModal(): void {

    this.stateModalDownload = true;
  }

  onResponseModalDownload(): void {

    this.stateModalDownload = false;
  }
}